import React, { Fragment, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import {
    IconButton,
    ListItemIcon,
    ListItemText,
    Menu,
    MenuItem,
    Tooltip,
} from '@material-ui/core';
import BlockIcon from '@material-ui/icons/Block';
import DeleteIcon from '@material-ui/icons/DeleteOutlined';
import MoreIcon from '@material-ui/icons/MoreVert';

const MoreOption = props => {

    const { optionList } = props;

    const moreRef = useRef(null);
    const [openMenu, setOpenMenu] = useState(false);

    const handleMenuOpen = () => {
        setOpenMenu(true);
    };

    const handleMenuClose = () => {
        setOpenMenu(false);
    };

    const def = [
        {nama: 'Clear Conversation', icon: DeleteIcon},
        {nama: 'Close Session', icon: BlockIcon}
    ]

    const menulist = optionList ? optionList : def
    console.log("menu", menulist)

    return (
        <div>

            <Tooltip title="More options">
                <IconButton size="small" onClick={handleMenuOpen} ref={moreRef}>
                    <MoreIcon />
                </IconButton>
            </Tooltip>
            <Menu
                anchorEl={moreRef.current}
                keepMounted
                onClose={handleMenuClose}
                open={openMenu}
            >
                {menulist.map(mn => (
                    <MenuItem key={mn.nama} button>
                        {/* {mn.icon &&
                            <ListItemIcon>
                                {mn.icon}
                            </ListItemIcon>
                        } */}
                        <ListItemText primary={mn.nama} />
                    </MenuItem>
                ))}
            </Menu>

        </div>
    );
};

MoreOption.propTypes = {
    optionList: PropTypes.array
};

export default MoreOption;
